"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

exports.__esModule = true;
/**
 * Serialize a Map into JSON
 */

exports["default"] = {
  type: 'Map',
  shouldTransform: function shouldTransform(type, obj) {
    return obj && obj.constructor && obj.constructor.name === 'Map';
  },
  toSerializable: function toSerializable(map) {
    var body = {};
    map.forEach(function (value, key) {
      var k = typeof key == 'object' ? JSON.stringify(key) : key;
      body[k] = value;
    });
    return {
      name: 'Map',
      body: body,
      proto: Object.getPrototypeOf(map).constructor.name
    };
  },
  fromSerializable: function fromSerializable(data) {
    var body = data.body;

    var obj = __assign({}, body);

    if (typeof data.proto === 'string') {
      // @ts-ignore
      obj.constructor = {
        name: data.proto
      };
    }

    return obj;
  }
};